import { render, staticRenderFns } from "./CombinationsSelectorProgressBar.vue?vue&type=template&id=2cb06062&scoped=true"
import script from "./CombinationsSelectorProgressBar.vue?vue&type=script&setup=true&lang=ts"
export * from "./CombinationsSelectorProgressBar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CombinationsSelectorProgressBar.vue?vue&type=style&index=0&id=2cb06062&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb06062",
  null
  
)

export default component.exports